import * as React from "react"
import { Box, Chip } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"

import {CheckIcon} from "../../@components";
import {productPageImageDetailsHideMasterImages, productPageImageDetailsDataModal} from "../../@signals";
import {PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS} from "../../constants";


export default function imagesColumn(key, label, pos) {
    return {
        name: key, label,
        options: {
            filter: false,
            customBodyRowRenderLite: (value, dataRow) => {
                const imageData = value[pos]
                const haveData = !!imageData
                const showIcon = !!imageData && imageData.similarity !== null

                return <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 2}}>
                    <Box sx={{ position: 'relative', width: 50, height: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center', opacity: 1}}>
                        {!haveData && <Box sx={{ textAlign: 'center' }}>--</Box> }

                        { pos === 10 && !!haveData && <Chip label={`+${value.slice(10).length}`} sx={{ p: 1 }} color="primary" />  }

                        { pos < 10 && !!haveData && <>
                            <ImageBlock
                                thumbnail={imageData.url}
                                dataRow={dataRow}
                                pos={pos}
                            />
                            <CheckIcon
                                show={showIcon}
                                status={imageData.checkStatus}
                            />
                        </> }
                    </Box>

                    {!!haveData && !productPageImageDetailsHideMasterImages.value && [PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS.FULL_MATCH, PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS.NO_POSITION_MATCH].includes(imageData.checkStatus) && <Box
                        sx={{ position: 'relative', width: 50, height: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center', opacity: 1}}>
                        { imageData.compareURL && <ImageSeeker src={imageData.compareURL} sx={{ width: 1, height: 1 }} /> }
                    </Box> }
                </Box>
            }
        }
    }
}

const ImageBlock = ({ thumbnail, dataRow, pos }) => {

    return <Box data-tour-trigger onClick={() => productPageImageDetailsDataModal.value = { ...dataRow, pos }} sx={{ cursor: 'pointer' }}>
        <ImageSeeker
            src={thumbnail}
            sx={{ width: 1, height: 1 }}
        />
    </Box>
}